import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=df97e1fa&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('df97e1fa')) {
      api.createRecord('df97e1fa', component.options)
    } else {
      api.reload('df97e1fa', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=df97e1fa&", function () {
      api.rerender('df97e1fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-27txQ2okAz1De/JS/comp/ImgFallback.vue"
export default component.exports